import { useMutation, useQuery } from '@tanstack/react-query';
import { showSwalAlert } from '../components/showSwalAlert';
import apiServices from '../ApiServices/request-handler';
import axios from 'axios';
const fetchCategory = async ({ queryKey }) => {
  const [, serviceId, page, limit] = queryKey;
  const response = await apiServices.getcategory(serviceId, page, limit);
  return response?.data?.data;
};

export const UseCategory = (serviceId, page, limit) => {
  return useQuery({
    queryKey: ['category', serviceId, page, limit],
    queryFn: fetchCategory,
  });
};

export const useCheckProjectMutation = (navigate, setLoadingToapi) => {
  return useMutation({
    mutationFn: async (checkProjectName) => {
      const response = await apiServices.checkProjectName(checkProjectName);
      return response?.data;
    },
    onSuccess: (data) => {
      //   showSwalAlert(data?.status, data?.message, "success");
      navigate(`/service/category/subcategory`);
      setLoadingToapi(false);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      setLoadingToapi(false);
      showSwalAlert('Oops...', message, 'error');
    },
  });
};

const fetchServices = async ({queryKey}) => {
  const [, page, limit] = queryKey;
  const response = await apiServices.getservice(page, limit);
  return response?.data?.data;
};

export const UseService = (page, limit) => {
  return useQuery({
    queryKey: ['service', page, limit],
    queryFn: fetchServices,
  });
};
const fetchSubCategories = async ({ queryKey }) => {
  const [, page, parentId, limit] = queryKey;
  const response = await apiServices.getSubCategories({
    page: page,
    parent: parentId,
    limit: limit,
  });
  return response?.data?.data;
};

export const useSubCategories = (currentPage, parentId, limit) => {
  return useQuery({
    queryKey: ['subCategories', currentPage, parentId, limit],
    queryFn: fetchSubCategories,
    enabled: !!parentId,
  });
};

export const useUploadPDFFileMutation = (
  setCancelUpload,
  setUploadProgress,
  setTimeLeft,
  setLoadingToapi,
  setImageUrls,
  setUploadedPDFFileURL,
  setUploadPDFFileRe
) => {
  return useMutation({
    mutationFn: async (uploadPdf) => {
      const response = await apiServices.uploadPdf(uploadPdf);
      return response?.data;
    },
    onSuccess: (data) => {
      const fileURL = data?.data?.pdf;
      const imageURL = data?.data?.images;
      setImageUrls(imageURL); // Assume the URL is in this path
      setUploadedPDFFileURL(fileURL);
      setUploadProgress(100);
      setTimeLeft(null);
      setCancelUpload(null);
      setUploadPDFFileRe(data.data.message);
      setLoadingToapi(false);
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert('Oops...', message, 'error');
    },
  });
};

export const useCreateProjectMutation = (
  setLoadingToapi,
  uploadedPDFFileURL,
  loadingToapi,
  setShowPopup
) => {
  return useMutation({
    mutationFn: async (createProject) => {
      const response = await apiServices.createProject(createProject);
      return response?.data;
    },
    onSuccess: (data) => {
      if (!uploadedPDFFileURL || loadingToapi) {
        setShowPopup(true);
      } else {
        setShowPopup(false);
      }
      setLoadingToapi(false);
      showSwalAlert('Project Create', data?.message, 'success');
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert('Oops...', message, 'error');
    },
  });
};
